import React, { useEffect, useState } from "react";
import { TextField, Button, Typography, Box } from "@mui/material";
import { useForm } from "react-hook-form";
import axios from "axios";
import { fixNumbers } from "../../../utils/utility";
import { toast } from "react-toastify";

const registerOptions = {
    firstName: { required: "نام اجباری است.", minLength: { value: 2, message: "نام باید حداقل ۲ حرف باشد" } },
    lastName: { required: "نام خانوادگی اجباری است.", minLength: { value: 2, message: "نام خانوادگی باید حداقل ۲ حرف باشد" } },
    giftCardNumber: { required: "شماره کارت اجباری است.", minLength: { value: 16, message: "شماره کارت هدیه باید حداقل ۱۶ رقم داشته باشد" } },
    national_code: {
        required: "کد ملی اجباری است",
        validate: {
            validateNumber: nationalId => {
                nationalId = fixNumbers(nationalId);
                // Check length is 10
                if (nationalId.length < 8 || 10 < nationalId.length) {
                    return "کد ملی اشتباه است";
                }
                //Check if all of the numbers are the same
                if (
                    nationalId == "0000000000" ||
                    nationalId == "1111111111" ||
                    nationalId == "2222222222" ||
                    nationalId == "3333333333" ||
                    nationalId == "4444444444" ||
                    nationalId == "5555555555" ||
                    nationalId == "6666666666" ||
                    nationalId == "7777777777" ||
                    nationalId == "8888888888" ||
                    nationalId == "9999999999"
                ) {
                    return "کد ملی اشتباه است";
                }

                // STEP 00 : if nationalId.lenght==8 add two zero on the left
                if (nationalId.length < 10) {
                    let zeroNeeded = 10 - nationalId.length;

                    let zeroString = "";
                    if (zeroNeeded == 2) {
                        zeroString = "00";
                    } else {
                        zeroString = "0";
                    }

                    nationalId = zeroString.concat(nationalId);
                }

                // STEP 1: Sum all numbers
                let sum = 0;
                for (let i = 0; i < 9; i++) {
                    sum += nationalId.charAt(i) * (10 - i);
                }

                // STEP 2: MOD ON 11
                let mod = sum % 11;

                // STEP 3: Check with 2
                let finalValue;
                if (mod >= 2) {
                    finalValue = 11 - mod;
                } else {
                    finalValue = mod;
                }

                // STEP 4: Final Step check with control value
                if (finalValue != nationalId.charAt(9)) {
                    return "کد ملی اشتباه است";
                }

                return true;
            },
        },
    },
};

const EventForm = () => {
    const [isSubmitted, setIsSubmitted] = useState(false);

    const accessToken = localStorage.getItem("accessToken");
    // const userInfo = JSON.parse(localStorage.getItem("userInformation"));

    // const phone_number = userInfo.phone_number;
    const [submittedPhone, setSubmittedPhone] = React.useState("");

    useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem("userInformation"));
        if (userInfo && userInfo.phone_number) {
            setSubmittedPhone(userInfo.phone_number);
        }
    }, []);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    const onSubmit = async data => {
        try {
            const payload = {
                first_name: data.firstName,
                last_name: data.lastName,
                national_code: data.national_code,
                card_number: data.giftCardNumber,
            };

            const response = await axios.post("https://api.atripa.ir/api/v2/account/user/event-signup/", payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 200) {
                toast.success("اطلاعات با موفقیت ارسال شد!", { toastId: "custom-id-yes" });
                // setSubmittedPhone(phone_number);
                setIsSubmitted(true);
                reset();
            }
        } catch (error) {
            console.error("❌ API Error:", error);
            console.log("Error response:", error.response.data.errors.detail[0]);

            if (error.response && error.response.status === 400) {
                // const backendMessage = error.response.data?.detail || "خطای نامشخصی رخ داده است.";
                toast.error(error.response.data.errors.detail[0], { toastId: "custom-id-yes" });
            } else {
                toast.error("ارسال اطلاعات با خطا مواجه شد.", { toastId: "custom-id-yes" });
            }
        }
    };

    return (
        <Box sx={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", px: 2 }}>
            {/* Rotated background image behind */}
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    // transform: {xs:"translateX(-65%) translateY(3%) rotate(2deg)", md:"translateX(-71%) translateY(10%) rotate(3deg)"},
                    transform: "translateX(-65%) translateY(10%) rotate(1deg)",
                    width: 300,
                    height: 500,
                    backgroundImage: "url('/Group 720.png')",
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    zIndex: 0,
                    display: { xs: "none", md: "block" },
                    // opacity: 0.4, // Optional: makes it look like a soft background
                }}
            />

            {/* Main form box on top */}
            <Box
                sx={{
                    backgroundImage: "url('/OBJECTS.png')",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%",
                    backgroundPosition: "center",
                    p: { xs: 3, md: 4 },
                    maxWidth: 300,
                    width: "100%",
                    minHeight: 500,
                    height: "auto",
                    mt: { md: 10 },
                    pt: { xs: 12, md: 12 },
                    textAlign: "center",
                    position: "relative",
                    zIndex: 1,
                }}
            >
                {isSubmitted ? (
                    <Box textAlign="center">
                        <Box display="flex" justifyContent="center" mb={1}>
                            <img src="/tick-circle.png" alt="success-icon" style={{ width: 40, height: 40 }} />
                        </Box>
                        <Typography sx={{ color: "#00925D", fontWeight: "bold", fontSize: "1rem" }}>ثبت نام شما با موفقیت انجام شد!</Typography>
                        <Typography sx={{ mt: 1, fontSize: "0.9rem" }}>
                            پیام رمز کارت رو به شماره <span style={{ fontWeight: "bold", direction: "ltr" }}>{submittedPhone}</span> ارسال کردیم.
                        </Typography>
                        <Box
                            sx={{
                                backgroundColor: "#FFF2E4",
                                color: "#FF8200",
                                p: 1,
                                mt: 2,
                                borderRadius: "8px",
                                fontSize: "0.85rem",
                            }}
                        >
                            *اگر پیام برات تا
                            <b> 15 دقیقه </b>
                            نیومد، با تیم پشتیبانی تماس بگیر.
                        </Box>
                        <Box mt={2} fontWeight="bold" fontSize="1rem">
                            <Typography>0417 165 0996</Typography>
                            <Typography> 0399 165 0996</Typography>
                        </Box>
                        <Button
                            fullWidth
                            variant="contained"
                            disabled
                            sx={{
                                mt: { xs: 11, md: 11 },
                                backgroundColor: "#808080",
                                "&:hover": {
                                    backgroundColor: "#808080",
                                },
                                color: "white",
                                height: 35,
                                textTransform: "none",
                                fontWeight: "bold",
                            }}
                        >
                            ثبت نام
                        </Button>
                    </Box>
                ) : (
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Typography variant="body2" gutterBottom>
                            اگه کارت رو پیدا کردی اطلاعات مربوط به خودتو وارد کن تا رمز کارت رو دریافت کنی:
                        </Typography>

                        <TextField
                            {...register("firstName", registerOptions.firstName)}
                            fullWidth
                            margin="dense"
                            label="نام"
                            variant="outlined"
                            size="small"
                            error={!!errors.firstName}
                            helperText={errors.firstName?.message}
                            sx={{ backgroundColor: "transparent" }}
                        />

                        <TextField
                            {...register("lastName", registerOptions.lastName)}
                            fullWidth
                            margin="dense"
                            label="نام خانوادگی"
                            variant="outlined"
                            size="small"
                            error={!!errors.lastName}
                            helperText={errors.lastName?.message}
                            sx={{ backgroundColor: "transparent" }}
                        />

                        <TextField
                            {...register("national_code", registerOptions.national_code)}
                            fullWidth
                            margin="dense"
                            label="کد ملی"
                            variant="outlined"
                            size="small"
                            error={!!errors.national_code}
                            helperText={errors.national_code?.message}
                            type="number"
                            sx={{
                                backgroundColor: "transparent",
                                "& input[type=number]::-webkit-inner-spin-button": {
                                    WebkitAppearance: "none",
                                },
                            }}
                        />

                        <TextField
                            {...register("giftCardNumber", registerOptions.giftCardNumber)}
                            fullWidth
                            margin="dense"
                            label="شماره کارت هدیه"
                            variant="outlined"
                            size="small"
                            error={!!errors.giftCardNumber}
                            helperText={errors.giftCardNumber?.message}
                            sx={{ backgroundColor: "transparent" }}
                        />

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{
                                mt: { xs: 11, md: 9 },
                                // backgroundImage: "url('/your-button-image.png')",
                                // backgroundRepeat: "no-repeat",
                                // backgroundSize: "cover",
                                // backgroundPosition: "center",
                                backgroundColor: "#006363",
                                "&:hover": {
                                    backgroundColor: "#006363",
                                },
                                color: "white",
                                height: 35,
                                textTransform: "none",
                                fontWeight: "bold",
                            }}
                        >
                            ثبت نام
                        </Button>
                    </form>
                )}
            </Box>
        </Box>
    );
};

export default EventForm;
